/**
 * Action types constant related to pdf rendering redux store state
 *
 * 반드시 알파벳 순서로 기록해주세요.
 */

export const PDF_CHANGE_CURRENT_PAGE_NUMBER = 'PDF_CHANGE_CURRENT_PAGE_NUMBER' as const;
export const PDF_CLEAR_ALL_STATE = 'PDF_CLEAR_ALL_STATE' as const;
export const PDF_LOAD_FAILURE = 'PDF_LOAD_FAILURE' as const;
export const PDF_LOAD_RETRY = 'PDF_LOAD_RETRY' as const;
export const PDF_LOAD_START = 'PDF_LOAD_START' as const;
export const PDF_LOAD_SUCCEED = 'PDF_LOAD_SUCCEED' as const;
export const PDF_NAVIGATE_TO_SPECIFIC_PAGE = 'PDF_NAVIGATE_TO_SPECIFIC_PAGE' as const;
export const PDF_PAGE_LEFT_POSITIONS_SET = 'PDF_PAGE_LEFT_POSITIONS_SET' as const;
export const PDF_PAGE_VIEWPORT_SET = 'PDF_PAGE_VIEWPORT_SET' as const;
export const PDF_SCALE_CHANGE = 'PDF_SCALE_CHANGE' as const;
export const PDF_SCALE_NORMALIZE = 'PDF_SCALE_NORMALIZE' as const;
export const PDF_VIEWER_PINCH_ZOOM_DISABLE = 'PDF_VIEWER_PINCH_ZOOM_DISABLE' as const;
export const PDF_VIEWER_SCALE_CHANGE = 'PDF_VIEWER_SCALE_CHANGE' as const;
